// texture.js
var AnimatedTexture = pc.createScript('animatedTexture');

AnimatedTexture.attributes.add('materialAsset', {
    type: 'asset',
    assetType: 'material'
});

AnimatedTexture.attributes.add('numFrames', {
    type: 'number',
    default: 1,
    description: 'Number of frames to play before looping'
});

AnimatedTexture.attributes.add('startFrame', {
    type: 'number',
    default: 0,
    description: 'Frame to start animation from'
});

AnimatedTexture.attributes.add('delayFrame', {
    type: 'number',
    default: -1,
    description: 'Frame to stop the animation'
});

AnimatedTexture.attributes.add('delayDuration', {
    type: 'number',
    default: 1,
    description: 'duration for the delay'
});

AnimatedTexture.attributes.add('width', {
    type: 'number',
    default: 1,
    description: 'Number of frames wide'
});

AnimatedTexture.attributes.add('height', {
    type: 'number',
    default: 1,
    description: 'Number of frames high'
});

AnimatedTexture.attributes.add('frameRate', {
    type: 'number',
    default: 1,
    description: 'Playback frames per second'
});


AnimatedTexture.prototype.delayFrameBuffer = 0;
AnimatedTexture.prototype.delayTick = 0;
AnimatedTexture.prototype.isDelaying = false;
AnimatedTexture.prototype.allowOneCycle = false;

// initialize code called once per entity
AnimatedTexture.prototype.initialize = function() {
    if (this.materialAsset) {
        this.material = this.materialAsset.resource;
    }
    
    this.timer = 1/this.frameRate;
    this.frame = this.startFrame;
    this.transform = new pc.Vec4();

    this.updateMaterial(this.frame);
    
    
    this.delayFrameBuffer = this.delayDuration * this.frameRate;
    //console.log(this.delayFrameBuffer, this.delayDuration, this.frameRate);
};

// update code called every frame
AnimatedTexture.prototype.update = function(dt) {
    
    //prevents update if numframes are static
    if(this.numFrames <= 1) { return;}
    
    // calculate when to animate to next frame
    this.timer -= dt;
    
    if (this.timer < 0) {
        if(this.isDelaying) {
            this.delayTick += 1;
            
            //console.log(this.delayTick, this.delayFrameBuffer);
            
            if(this.delayTick >= this.delayFrameBuffer) {
                this.delayTick = 0;
                this.isDelaying = false;
            }
            
            this.frame = this.delayFrame;
        } else {
            // move to next frame
            this.frame++;
        }
        
        
        if (this.frame >= (this.numFrames + this.startFrame)) {
            this.frame = this.startFrame;
        }

        this.updateMaterial(this.frame);
        
        //checking if a delay frame is set and setting flag on first match
        if(this.delayFrame >= 0) {
            if(this.delayFrame == this.frame && !this.isDelaying){
                if(this.allowOneCycle) {
                    this.isDelaying = true;    
                }
                this.allowOneCycle = !this.allowOneCycle;
            }    
        }
        
        // reset the timer
        this.timer = 1/this.frameRate;
    }
};



AnimatedTexture.prototype.updateMaterial = function (frame) {
    // calculate how much to change UV to go to next frame
    var dx = 1 / this.width;
    var dy = 1 / this.height;

    // Convert frame number into UV co-ordinate
    var x = frame % this.width;
    var y = Math.floor(frame / this.width);

    var meshes = this.entity.model.meshInstances;

    // create the transform vector (tilingx, tilingy, offsetx, offsety)
    // and override the material properties for this mesh
    // This allows us to use different settings for different Entities, but share the same material
    this.transform.set(dx, dy, x * dx, (1 - dy) - (y * dy));
    
    var data = [this.transform.x, this.transform.y, this.transform.z, this.transform.w];
    
    if(meshes !== null) {
        for (var i = 0; i < meshes.length; i++) {
            meshes[i].setParameter("texture_diffuseMapTransform", data);
            meshes[i].setParameter("texture_emissiveMapTransform", data);
            meshes[i].setParameter("texture_opacityMapTransform", data);
        }
    }
    
};


